import React, { useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, Row, Spin } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { SearchOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import { validations } from "../../../../config/validations/validations";
import { disabledSaveBtn } from "../../../../config/Global";

const SearchList: React.FC<any> = (props) => {
  const { getList, providerListByCodes } = props;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);
  // const [typeAction, setTypeAction] = useState<string>('daily');

  const handleSubmit = (data) => {
    setLoading(true);
    let report_year;
    let report_date;

    if (data?.report_year) {
      report_year = dayjs(data?.report_year).format("YYYY");
    }
    if (data?.type === "daily") {
      report_date = data?.report_date
        ? dayjs(data?.report_date).format("YYYY-MM-DD")
        : "";
    }

    const payload = {
      type: data?.type,
      report_date: report_date ?? "",
      report_year: report_year ?? "",
      provider_code: data.provider_code?.toLowerCase(),
    };
    if (payload) {
      setLoading(false);
      getList(payload);
      setDisabledClear(false);
    }

    // dispatch(fetchListReports(payload))
    //   .then((res: any) => {
    //     setLoading(false);
    //     // handleAddModal();
    //   })
    //   .catch((error: any) => {
    //     console.log("error",error);

    //     // handleAddModal();
    //     // getList();
    //   });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf("day"));
  };

  const disabledDateForYear = (current: Dayjs) => {
    // Disable years before 2022 and years after the current year
    const currentYear = dayjs().year();
    return current && (current.year() < 2022 || current.year() > currentYear);
  };
  useEffect(() => {
    form.setFields([
      {
        name: "type",
        errors: ["It is required."],
      },
    ]);
  }, [form]);
  return (
    <FormBox
      className="filterForm"
      form={form}
      onFinish={handleSubmit}
      onChange={handleChange}
      validateTrigger={["onBlur", "onInput"]}
      autoComplete="off"
    >
      <Row gutter={20} align={"middle"}>
        <Col xs={12} md={12} lg={8} xl={6}>
          <InputBox.Radio
            type="button"
            label="Type"
            name={"type"}
            size="large"
            options={{
              list: [
                { label: "Daily", value: "daily" },
                { label: "Weekly", value: "weekly" },
                { label: "Monthly", value: "monthly" },
              ],
              valueKey: "value",
              textKey: "label",
            }}
            required
            rules={[validations.required.text("Type")]}
            // onChange={(e: any) => {
            //   setTypeAction(e.target.value);
            // }}
          />
        </Col>
        <Col xs={12} md={12} lg={8} xl={4}>
          <InputBox.Select
            label="To Provider"
            name={"provider_code"}
            allowClear
            showSearch
            placeholder="Select To Provider"
            tooltip="Select To Provider"
            notFoundContent={providerListByCodes?.length > 0 ? null : <Spin />}
            options={{
              list: providerListByCodes?.length > 0 ? providerListByCodes : [],
              valueKey: "id",
              textKey: "provider_code",
            }}
          />
        </Col>

        <Col xs={12} md={12} lg={8} xl={4}>
          <Form.Item label="Select Date" name={"report_date"}>
            <DatePicker
              placeholder={"Select Date"}
              disabledDate={disabledDate}
            />
          </Form.Item>
        </Col>
        <Col xs={12} md={12} lg={8} xl={4}>
          <Form.Item label="Select Year" name={"report_year"}>
            <DatePicker
              placeholder={"Select Year"}
              picker="year"
              disabledDate={disabledDateForYear}
            />
          </Form.Item>
        </Col>
        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={disabledSearch}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type="default"
            htmlType="reset"
            disabled={disabledClear}
            onClick={() => {
              getList();
              form.resetFields();
              form.setFields([
                {
                  name: "type",
                  errors: ["It is required."],
                },
              ]);
              setDisabledSearch(true);
              setDisabledClear(true);
            }}
          >
            Clear
          </Button>
        </Col>
      </Row>
    </FormBox>
  );
};

export default SearchList;
